// Constants
const DAILY_CONSUMPTION_PER_PERSON = 330; // liters per person per day
const WARNING_THRESHOLD = 0.8; // 80% of daily limit
const CRITICAL_THRESHOLD = 1.0; // 100% of daily limit

export const calculateDailyLimit = (householdMembers) => {
  return householdMembers * DAILY_CONSUMPTION_PER_PERSON;
};

export const getConsumptionStatus = (currentConsumption, householdMembers) => {
  const dailyLimit = calculateDailyLimit(householdMembers);
  const warningLimit = dailyLimit * WARNING_THRESHOLD;
  const criticalLimit = dailyLimit * CRITICAL_THRESHOLD;

  if (currentConsumption >= criticalLimit) {
    return {
      status: 'error',
      message: '¡Consumo excesivo!',
      percentage: (currentConsumption / dailyLimit) * 100
    };
  } else if (currentConsumption >= warningLimit) {
    return {
      status: 'warning',
      message: 'Consumo elevado',
      percentage: (currentConsumption / dailyLimit) * 100
    };
  } else {
    return {
      status: 'success',
      message: 'Consumo óptimo',
      percentage: (currentConsumption / dailyLimit) * 100
    };
  }
};

// export const getConsumptionStatus = (currentConsumption, householdMembers, dailyGoal = null) => {
//   const dailyLimit = dailyGoal ? dailyGoal : calculateDailyLimit(householdMembers);
//   const warningLimit = dailyLimit * WARNING_THRESHOLD;
//   const criticalLimit = dailyLimit * CRITICAL_THRESHOLD;
//   // ... resto igual
// };

export const getHourlyLimit = (householdMembers) => {
  return calculateDailyLimit(householdMembers) / 24;
};

export const formatConsumption = (liters) => {
  return `${Math.round(liters)} L`;
}; 